import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "block items-center space-y-2 md:flex" }
const _hoisted_2 = { class: "flex flex-1 items-center" }
const _hoisted_3 = { class: "flex items-center space-x-2 font-semibold text-gray-800" }
const _hoisted_4 = { class: "text-sm text-gray-700" }
const _hoisted_5 = { class: "flex flex-1 items-center" }
const _hoisted_6 = { class: "flex flex-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-1 items-center"
}
const _hoisted_8 = { class: "flex flex-wrap pr-3 md:pr-0" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-gray-600 md:hidden"
}
const _hoisted_10 = {
  key: 1,
  class: "flex justify-end space-x-1"
}
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = { class: "sr-only" }
const _hoisted_13 = { class: "sr-only" }
const _hoisted_14 = { class: "col-span-9 mt-3 grid grid-cols-1 gap-3 border-t pt-3 lg:grid-cols-4 lg:gap-0" }
const _hoisted_15 = { class: "flex flex-wrap items-center space-x-0.5 text-xs text-gray-500" }
const _hoisted_16 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_17 = { class: "flex flex-wrap items-center space-x-0.5 text-xs text-gray-500" }
const _hoisted_18 = {
  key: 0,
  class: "rounded border bg-white px-1.5 py-0.5 text-xs text-gray-500"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex items-center justify-end text-xs text-gray-500" }
const _hoisted_21 = { class: "flex flex-wrap" }
const _hoisted_22 = { class: "flex items-center justify-end text-xs text-gray-500" }
const _hoisted_23 = { class: "flex flex-wrap" }

import { computed, PropType } from 'vue';
import router from '@/router';

import moment from 'moment';
import {
    FolderIcon,
    CheckCircleIcon,
    XCircleIcon,
    PencilAltIcon,
    LockClosedIcon,
    ClockIcon,
} from '@heroicons/vue/outline';
import { UserModel, Permission } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserListItem',
  props: {
    modelValue: {
        type: Object as PropType<UserModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const levels = computed(() => __props.modelValue.levels || []);
const limitedLevels = computed(() => levels.value.slice(0, 3));
const roles = computed(() => __props.modelValue?.roles || []);

const handleActivateClick = () => emit('activate', __props.modelValue);
const handleInactivateClick = () => emit('inactivate', __props.modelValue);

const trimText = (text: string, limit: number) => {
    if (text.length <= limit) {
        return text;
    } else {
        return text.slice(0, limit - 3) + '...';
    }
};

const handleEditClick = () => {
    router.push({
        name: 'EditUserById',
        params: {
            id: __props.modelValue.id,
        },
    });
};

return (_ctx: any,_cache: any) => {
  const _component_UiGravatar = _resolveComponent("UiGravatar")!
  const _component_UiIsActiveBadge = _resolveComponent("UiIsActiveBadge")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "flex flex-col hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UiGravatar, {
            email: __props.modelValue.email,
            name: __props.modelValue.name,
            class: "mr-2 h-12 w-12 rounded-full ring-1 ring-gray-300 focus:ring-2 focus:ring-opacity-50"
          }, null, 8, ["email", "name"]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_3, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_USER) ? 'RouterLink' : 'span'), {
                to: {
                                name: 'ViewUserById',
                                params: {
                                    id: __props.modelValue?.id,
                                },
                            },
                class: "text-primary"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(trimText(__props.modelValue.name, 25)), 1)
                ]),
                _: 1
              }, 8, ["to"])),
              _createVNode(_component_UiIsActiveBadge, {
                "model-value": __props.modelValue,
                class: "ml-2 text-xs"
              }, null, 8, ["model-value"])
            ]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.modelValue.email), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(LockClosedIcon), {
            class: "mr-1 h-5 w-5 flex-shrink-0 text-gray-400",
            "aria-hidden": "true"
          }),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role, index) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_ROLE) ? 'RouterLink' : 'span'), {
                key: `role${role.id}`,
                to: {
                            name: 'ViewRoleById',
                            params: {
                                id: role.id,
                            },
                        },
                class: _normalizeClass([
                            index != roles.value.length - 1 ? 'mr-0.5' : '',
                            _ctx.$can(_unref(Permission).VIEW_ROLE) ? 'text-primary' : 'text-gray-500',
                            'text-xs font-medium',
                        ])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(role.name) + _toDisplayString(index != roles.value.length - 1 ? ',' : ''), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128))
          ])
        ]),
        (_ctx.$can(_unref(Permission).VIEW_LEVELS))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_unref(FolderIcon), {
                class: "mr-1 h-5 w-5 flex-shrink-0 text-gray-400",
                "aria-hidden": "true"
              }),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (level, index) => {
                  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_LEVEL) ? 'RouterLink' : 'span'), {
                    key: level.id,
                    to: {
                            name: 'ViewLevelById',
                            params: {
                                id: level.id,
                            },
                        },
                    class: _normalizeClass([
                            index != levels.value.length - 1 ? 'mr-0.5' : '',
                            'text-primary hidden text-xs font-medium md:block',
                        ])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(level.name) + _toDisplayString(index != levels.value.length - 1 ? ',' : ''), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedLevels.value, (level, index) => {
                  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_LEVEL) ? 'RouterLink' : 'span'), {
                    key: level.id,
                    to: {
                            name: 'ViewLevelById',
                            params: {
                                id: level.id,
                            },
                        },
                    class: _normalizeClass([
                            index != limitedLevels.value.length - 1 ? 'mr-0.5' : '',
                            'text-primary text-xs font-medium md:hidden',
                        ])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(level.name) + _toDisplayString(index != limitedLevels.value.length - 1 ? ',' : ''), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128)),
                (limitedLevels.value.length > 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " ..." + _toDisplayString(_ctx.$t('core.actions.Edit')) + " " + _toDisplayString(levels.value.length - 3), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.$can(_unref(Permission).EDIT_USER))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (__props.modelValue?.isActive)
                ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 0,
                    variant: "danger",
                    onClick: handleInactivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('core.actions.Inactivate')), 1),
                      _createVNode(_unref(XCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Inactivate')]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 1,
                    variant: "success",
                    onClick: handleActivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('core.actions.Activate')), 1),
                      _createVNode(_unref(CheckCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Activate')]
                  ]),
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                onClick: handleEditClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('core.actions.Edit')), 1),
                  _createVNode(_unref(PencilAltIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })), [
                [_directive_tippy, _ctx.$t('core.actions.Edit')]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('core.entity.Devices')) + ":", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue.devices, (device) => {
              return (_openBlock(), _createElementBlock("span", {
                key: device.deviceType,
                class: "rounded border bg-white px-1.5 py-0.5 text-xs text-gray-500"
              }, _toDisplayString(_ctx.$t('user.labels.devices.' + device.deviceType)), 1))
            }), 128)),
            (!__props.modelValue.devices?.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('user.labels.devices.null')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('user.labels.extension.number')) + ":", 1),
            (__props.modelValue.extension?.number)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(__props.modelValue.extension?.number), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_unref(ClockIcon), {
              class: "mr-0.5 h-4 w-4 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('user.labels.lastLoginDevice')) + ": " + _toDisplayString(__props.modelValue.lastDeviceLogin
                                ? _unref(moment)(__props.modelValue.lastDeviceLogin).format('DD/MM/YYYY HH:mm:ss')
                                : '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_unref(ClockIcon), {
              class: "mr-0.5 h-4 w-4 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('user.labels.lastLoginPortal')) + ": " + _toDisplayString(__props.modelValue.lastLogin
                                ? _unref(moment)(__props.modelValue.lastLogin).format('DD/MM/YYYY HH:mm:ss')
                                : '-'), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})